import { useNavigate } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'
import { OneEmptyState } from '@factorialco/f0-react/dist/experimental'
import { WorkAreaManagePolicyDocument } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

interface Props {
  workAreaId: string
  locationId: string
}

const EmptyState = ({ workAreaId, locationId }: Props) => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()

  const { data } = useQuery(WorkAreaManagePolicyDocument)
  const canManageWorkArea = data?.locations?._policies?.workAreaManage?.can ?? false

  const editWorkArea = () => {
    if (!locationId) return

    track(trackingEvents.spaceControl.editWorkArea, {})
    navigate({
      pathname: navigation.settings.locations.locationsId.workAreas.workAreaIdEdit.fullPath({
        id: locationId,
        workAreaId: workAreaId,
      }),
    })
  }

  const actions =
    !canManageWorkArea || !locationId
      ? []
      : [
          {
            label: i18n.t('space_control.overview.go_to_settings'),
            onClick: editWorkArea,
            type: 'default' as const,
            variant: 'outline' as const,
          },
        ]

  return (
    <Box flexGrow>
      <OneEmptyState
        title={i18n.t('space_control.overview.no_map_configured')}
        description=""
        emoji={'🗺️'}
        actions={actions}
      />
    </Box>
  )
}

export default observer(EmptyState)
